/**
 * @flow
 * @relayHash 2e87f93c5bdf6229158b7163719249c8
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UploadCombinedPhotoInput = {|
  eventId: string,
  photo: any,
  startnumber: string,
|};
export type UploadCombinedPhotoMutationVariables = {|
  input: UploadCombinedPhotoInput
|};
export type UploadCombinedPhotoMutationResponse = {|
  +uploadCombinedPhoto: ?{|
    +startnumber: ?string
  |}
|};
export type UploadCombinedPhotoMutation = {|
  variables: UploadCombinedPhotoMutationVariables,
  response: UploadCombinedPhotoMutationResponse,
|};
*/


/*
mutation UploadCombinedPhotoMutation(
  $input: UploadCombinedPhotoInput!
) {
  uploadCombinedPhoto(input: $input) {
    startnumber
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UploadCombinedPhotoInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "uploadCombinedPhoto",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UploadCombinedPhotoPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "startnumber",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UploadCombinedPhotoMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UploadCombinedPhotoMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UploadCombinedPhotoMutation",
    "id": null,
    "text": "mutation UploadCombinedPhotoMutation(\n  $input: UploadCombinedPhotoInput!\n) {\n  uploadCombinedPhoto(input: $input) {\n    startnumber\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b602a01dc4eff169508b3e6f1a54d7a4';

module.exports = node;
